<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="structure">
<p class="structure">{~?~begin epigraph}</p>
<div class="epigraph">
<p class="epaft"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>It is evident that the opening lines of “Go Down, Moses,”</p>
<p class="epaft">Go down, Moses,</p>
<p class="epaft">’Way down in Egypt land;’</p>
<p class="epaft">Tell old Pharaoh,</p>
<p class="epaft">Let my people go.</p>
<p class="epaft">have a significance beyond the bondage of Israel in Egypt.</p>
<p class="ept">–James Weldon Johnson, <i>The Book of American Negro Poetry</i>, 1922</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Marbury-0006.vue?0972a8f2